"use client";

import { useEffect, useState } from "react";

interface Props {
    target: string; // ISO date string
}

interface TimeLeft {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

function calcTimeLeft(target: string): TimeLeft {
    const diff = Math.max(0, new Date(target).getTime() - Date.now());
    return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
    };
}

export function Countdown({ target }: Props) {
    const [time, setTime] = useState<TimeLeft | null>(null);

    useEffect(() => {
        setTime(calcTimeLeft(target));
        const id = setInterval(() => setTime(calcTimeLeft(target)), 1000);
        return () => clearInterval(id);
    }, [target]);

    if (!time) return null; // SSR-safe: ne rendereljünk a hydration előtt

    const items = [
        { value: time.days,    label: "nap" },
        { value: time.hours,   label: "óra" },
        { value: time.minutes, label: "perc" },
        { value: time.seconds, label: "mp" },
    ];

    return (
        <div className="flex items-center justify-center gap-3 md:gap-5">
            {items.map(({ value, label }, i) => (
                <div key={label} className="flex items-center gap-3 md:gap-5">
                    <div className="flex flex-col items-center">
                        <div
                            className="flex items-center justify-center rounded-xl font-black tabular-nums"
                            style={{
                                width: "clamp(56px, 12vw, 80px)",
                                height: "clamp(56px, 12vw, 80px)",
                                fontSize: "clamp(1.5rem, 4vw, 2.25rem)",
                                background: "#0a0a18",
                                border: "1px solid rgba(124,58,237,0.3)",
                                color: "#f8fafc",
                                letterSpacing: "-0.04em",
                            }}
                        >
                            {String(value).padStart(2, "0")}
                        </div>
                        <span
                            className="mt-2 text-xs uppercase tracking-widest"
                            style={{ color: "#475569", fontSize: "0.65rem" }}
                        >
                            {label}
                        </span>
                    </div>
                    {i < items.length - 1 && (
                        <span
                            className="font-black pb-5"
                            style={{ color: "rgba(124,58,237,0.5)", fontSize: "1.25rem" }}
                        >
                            :
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
}
